import * as React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useStyles } from '@wix/tpa-settings/dist/src/hooks';
import { instagramStyleParams } from '../../../../settings';
import { SIZE } from 'wix-ui-tpa/Button';
import { ReactComponent as Instagram } from '../../../../../assets/instagram_icon.svg';
import { Button } from '../../common';
import { openInstagramAccount } from '../../../../actions/headerActions';

import { st, classes } from './FollowBtn.st.css';
import { userInfo } from 'os';

const FollowBtn = ({
  isHeaderLayoutCenter,
  m_isHeaderLayoutCenter,
  isMobile,
  user,
  followBtnText,
  showMoreFontGrid,
  isDisplayFollowBtn,
  m_isDisplayFollowBtn,
  mobileShowMoreFontSize,
  isV4Styles,
}) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const [isHover, setHover] = React.useState(false);

  const buttonFontSize = isMobile
    ? mobileShowMoreFontSize
    : (showMoreFontGrid && showMoreFontGrid.size) ||
      styles.get(instagramStyleParams.showMoreFontGrid).size;

  const isDisplay = isMobile ? m_isDisplayFollowBtn : isDisplayFollowBtn;
  const isCenter = isMobile ? m_isHeaderLayoutCenter : isHeaderLayoutCenter;

  if (!isDisplay) {
    return <div id="followBtn" />;
  }

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      id="followBtn"
      className={st(classes.WarpFollowBtn, {
        isHeaderLayoutCenter: isCenter,
        isMobile,
      })}
    >
      <Button
        isMobile={isMobile}
        fullWidth={isMobile}
        isOldStyle={isV4Styles}
        size={isMobile ? SIZE.tiny : SIZE.small}
        onClick={
          user.username === 'urban.weekends' ? () => {} : openInstagramAccount
        }
        content={
          <div className={st(classes.Items)}>
            <Instagram
              className={st(classes.InstagramIcon, { isHover })}
              width={buttonFontSize}
              height={buttonFontSize}
            />
            {followBtnText || t('profileHeader.followBtn')}
          </div>
        }
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isMobile: state.appReducer.isMobile,
  user: state.appReducer.user,
  isHeaderLayoutCenter: state.settingsReducer.isHeaderLayoutCenter,
  m_isHeaderLayoutCenter: state.settingsReducer.m_isHeaderLayoutCenter,
  followBtnText: state.settingsReducer.followBtnText,
  showMoreFontGrid: state.settingsReducer.showMoreFontGrid,
  isDisplayFollowBtn: state.settingsReducer.isDisplayFollowBtn,
  m_isDisplayFollowBtn: state.settingsReducer.m_isDisplayFollowBtn,
  mobileShowMoreFontSize: state.settingsReducer.mobileShowMoreFontSize,
  isV4Styles: state.settingsReducer.isV4Styles,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FollowBtn);
